<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">카테고리 검색</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                      @click="close()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              <table class="table table-hover table-bordered">
                <tr>
                  <th>카테고리명</th>
                  <td><input @keyup.enter="getCategories()" v-model="filter.title" type="text" class="form-control" id="colFormLabel"/></td>
                  <td class="txt-center">
                    <button @click="getCategories()" class="btn btn-primary">검색</button>
                  </td>
                </tr>
              </table>

              <table class="table table-hover table-bordered mt-30 text-center">
                <tr>
                  <th>No</th>
                  <th>카테고리</th>
                  <th>등록일</th>
                  <th>HQ매니저</th>
                  <th>삭제</th>
                </tr>
                <tr v-for="(category, index) in popCategories" :key="category.idx">
                  <td>{{ (popCategories.length - index) }}</td>
                  <td>{{ category.name }}</td>
                  <td>{{ category.createDate }}</td>
                  <td>{{ category.empName }}</td>
                  <td><button class="btn btn-outline-primary" @click="pickCategory(category)">선택</button></td>
                </tr>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'tutorModal',
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
  },

  data: () => ({
    popCategories: [],
    category: {},
    filter: {
      title: null,
    },
  }),

  watch: {
    visible: function (newVal) {
      if (newVal == true) {
        this.visible = true;
        // this.doSearch();
      } else {
        this.visible = false;
      }
    }
  },
  mounted() {
    this.axios.get(this.$store.state.host + "/v1/admin/programs/category")
    .then((res) => {
      this.popCategories = res.data.result;
    });
  },

  methods: {
    pickCategory(category) {
      this.$emit('pick', category);
      this.close();
    },
    close() {
      this.$emit("close", false);
    },
    getCategories: function () {
      const params = {
        title: this.filter.title
      };

      this.axios.get(this.$store.state.host + "/v1/admin/programs/category", {params})
      .then((res) => {
        this.popCategories = res.data.result;
      });
    },
    postCategory: function () {
      const url = this.$store.state.host + "/v1/admin/programs/category";
      this.axios.post(url, this.category)
      .then((res) => {
        if (res.data.status === 100) {
          alert(res.data.result)
        } else {
          this.getCategories();
        }
        console.log(res);
      });
    },
    deleteCategory: function (idx) {
      const url = this.$store.state.host + "/v1/admin/programs/category/" + idx;
      this.axios.delete(url)
      .then((res) => {
        if (res.data.status === 0) {
          this.getCategories();
        }else{
          alert(res.data.result);
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}
</style>
